import OpenTicketSearch from './OpenTicketSearchContainer';

export default OpenTicketSearch;
